module.exports = __webpack_public_path__ + "static/media/nursery.4649bb99.svg";